<template>
    <div class="tsa-button"
        :class="['tsa-button-' + size, plain ? 'plain' : '', 'tsa-type-' + type, disabled ? 'disabled' : '', round ? 'round' : '']"
        @click="clickFunction"
        :style="{ height: btnSize[size]['height'], background: backGroundColor, borderRadius: btnSize[size]['borderRadius']}"
        
    >
        <button :style="{ fontSize: btnSize[size]['fontSize'] }">
            <span v-if="loading" class="el-icon-loading"></span><span class="icon" :class="icon" v-if="icon"></span><slot /></button>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        plain: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'primary' // default, primary, success, warning, danger
        },
        size: {
            type: String,
            default: 'medium' // large medium small mini
        },
        icon: {
            type: String,
            default: ''
        },
        backGroundColor: {
            type: String,
            default: ''
        },
        round: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            btnSize: {
                large: {
                    height: '72px',
                    fontSize: '18px',
                    borderRadius: '8px'
                },
                medium: {
                    height: '44px',
                    fontSize: '14px',
                    borderRadius: '8px'
                },
                mediumer: {
                    height: '42px',
                    fontSize: '16px',
                    borderRadius: '6px'
                },
                small: {
                    height: '36px',
                    fontSize: '14px',
                    borderRadius: '6px'
                },
                smaller: {
                    height: '32px',
                    fontSize: '14px',
                    borderRadius: '6px'
                },
                mini: {
                    height: '24px',
                    fontSize: '12px'
                }
            }
        }
    },
    methods: {
        clickFunction() {
            if (this.loading || this.disabled) {
                return
            }
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
    // #1F5EFF
    .tsa-button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        &.round {
            border-radius: 99px!important;
        }
        &.tsa-type-primary {
            background: #0047FF;
            &:hover {
                background: #0340db!important;
            }
            &.plain {
                background: #fff;
                border: 1px solid #0047FF;
                &:hover {
                    background: #f0eeee!important;
                }
                button {
                    color: #0047FF;
                }
            }
            button {
                color: #fff;
            }
        }
        &.tsa-type-default {
            background: #ffffff;
            &:hover {
                background: #ffffff!important;
            }
            &.plain {
                background: #fff;
                border: 1px solid #D9D9D9;
                &:hover {
                    background: #f0eeee!important;
                }
                button {
                    color: #000000;
                }
            }
            button {
                color: #000000;
            }
        }
        button {
            width: 100%;
            height: 100%;
            border: 0;
            background: transparent;
            color: #fff;
            cursor: pointer;
            line-height: normal;
            .el-icon-loading {
                margin-right: 4px;
            }
        }
    }
</style>